export default {
  SET_CAMPAIGN(state, campaign) {
    state.campaign = campaign
  },
  SET_SUBMITTED_HOURS(state, submitted_hours) {
    state.submitted_hours = submitted_hours
  },
  SET_MANAGER_SUBMITTED_HOURS(state, manager_submitted_hours) {
    state.manager_submitted_hours = manager_submitted_hours
  },
  SET_SELECTED_SUBMIT_HOURS(state, selected_submit_hours) {
    state.selected_submit_hours = selected_submit_hours
  },
  SET_MANAGER_SELECTED_SUBMIT_HOURS(state, manager_selected_submit_hours) {
    state.manager_selected_submit_hours = manager_selected_submit_hours
  },
  REMOVE_CAMPAIGN(state, itemId) {
      const campaignIndex = state.campaign.datas.findIndex((u) => u.id == itemId)
      state.campaign.datas.splice(campaignIndex, 1)
  },
  SELECTED_CAMPAIGN(state,data){
    state.campaign.datas = []
    state.campaign.total = 1;
    state.campaign.per_page = 1;
    state.campaign.datas.push(data)
  },
  SET_AUTOCOMPLETE_DATA(state,data){
    state.autocomplete_data = data
  },
  SET_CAMPAIGN_STATUS(state,data){
    state.campaign_status = data
  },
    EDIT_ITEM(state,data){
    state.campaign = data
  },
  ADD_ITEM(state,data){
    state.campaign = data
  },
  SET_USER_SUBMITTED_HOURS(state,data){
    state.user_submitted_hours = data
  },
  SET_COMMENT_FIELD(state,data){
    state.set_comment_field = data
  },
  SET_Client__DASHBOARD(state, client_dashboard) {
    state.client_dashboard = client_dashboard
  },
}
